module.exports = __webpack_public_path__ + "img/apple.c40f5721.png";